/** @jsx jsx */
import PropTypes from "prop-types"
import { Children } from "react"
import { jsx, Styled } from "theme-ui"

export default function Title({ children }) {
  if (Children.count(children)) {
    return (
      <Styled.h2
        sx={{
          variant: "caption",
          textAlign: ["center", "center", "left"],
          fontSize: [2, 3, 3],
        }}
      >
        {children}
      </Styled.h2>
    )
  }
  return null
}

Title.defaultProps = {
  children: null,
}

Title.propTypes = {
  children: PropTypes.node,
}
